export const UKHAB_BASELINE_SURVEY_NAME = 'UKHab Survey';
export const UKHAB_PRESURVEY_SURVEY_NAME = 'UKHab Pre-survey';

export const isUkhabBaselineForm = (form: { name: string }): boolean => {
  return form.name === UKHAB_BASELINE_SURVEY_NAME;
};

export const isUkhabPresurveyForm = (form: { name: string }): boolean => {
  return form.name === UKHAB_PRESURVEY_SURVEY_NAME;
};

export const isUkhabApp = (forms: { name: string }[]): boolean => {
  return forms.some(isUkhabBaselineForm);
};
